import { render, staticRenderFns } from "./RemoveMaterialVariant.vue?vue&type=template&id=4a7d1c5e&scoped=true"
import script from "./RemoveMaterialVariant.vue?vue&type=script&lang=js"
export * from "./RemoveMaterialVariant.vue?vue&type=script&lang=js"
import style0 from "./RemoveMaterialVariant.vue?vue&type=style&index=0&id=4a7d1c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d1c5e",
  null
  
)

export default component.exports